import state from "./moduleUserAddState.js";
import mutations from "./moduleUserViewAddMutations.js";
import actions from "./moduleUserAddActions.js";
import getters from "./moduleUserAddGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
